export const floatingActions = {
	massEdit: "Mass edit products",
	editExcel: "Import via Excel",
	testFiscal: "Test fiscal integration",
	testFiscalData: "Test fiscal data",
	syncWithDelivery: "Sync with delivery",
	deleteSelected: "Delete selected products",
};
